import type { Volume } from '../types/content'

export const volumes: Volume[] = [
  {
    number: 'TOMO 01',
    title: '🌌 Le Leggi Sistemiche',
    subtitle: 'Gli Ordini dell’Amore',
    description:
      'Ogni famiglia funziona secondo 3 leggi invisibili. Quando si rompono, il dolore si ripete tra le generazioni. Impara a leggere il tuo sistema e a cartografare le forze nascoste che governano la tua vita.',
    tags: ['Leggi Sistemiche', 'Mappe Familiari', 'Schemi Illustrati', 'Frasi di Guarigione'],
  },
  {
    number: 'TOMO 02',
    title: '🌸 La Ferita della Madre',
    subtitle: 'Guarire il Legame alla Fonte della Vita',
    description:
      'Il tuo legame con tua madre può influenzare la tua autostima e certe dinamiche relazionali. Ripristina la connessione più fondamentale che un essere umano possa avere.',
    tags: ['Ferita Materna', 'Script di Guarigione', 'Protocolli Pratici', 'Stampabile'],
    featured: true,
  },
  {
    number: 'TOMO 03',
    title: '⚡ La Forza del Padre',
    subtitle: 'Recuperare la Propria Potenza nel Mondo',
    description:
      'La relazione paterna può influenzare la tua fiducia, la tua autonomia e il tuo rapporto con il mondo. Libera il giudizio e recupera la forza che ti appartiene di diritto.',
    tags: ['Blocchi Finanziari', 'Fiducia', 'Potenza', 'Protocolli'],
  },
  {
    number: 'TOMO 04',
    title: '🌑 L’Ombra degli Antenati',
    subtitle: 'Spezzare le Lealtà Invisibili',
    description:
      'I segreti di famiglia e le tragedie dimenticate vivono in te come lealtà invisibili. Liberati dai destini che non hai mai dovuto portare.',
    tags: ['Mappe Ancestrali', 'Lealtà Transgenerazionali', 'Liberazione', 'Schemi Illustrati'],
    featured: true,
  },
  {
    number: 'TOMO 05',
    title: '💫 L’Architettura del Bambino Interiore',
    subtitle: 'Guarire il Sistema dall’Origine',
    description:
      'Il bambino ferito dentro di te prende decisioni da adulto. Esplora le cinque ferite emotive fondamentali che alimentano i tuoi schemi più profondi.',
    tags: ['Bambino Interiore', '5 Ferite', 'Rigenitorialità Sistemica', 'Carte Pratiche'],
  },
  {
    number: 'TOMO 06',
    title: '✨ Riscrivere il Tuo Destino',
    subtitle: 'Integrazione e Nuovo Racconto',
    description:
      'Nuovi rituali, un genogramma di soluzione e un piano di integrazione di 90 giorni. Ancora il tuo percorso e scrivi l’eredità che solo tu puoi lasciare.',
    tags: ['Piano 90 Giorni', 'Genogramma di Soluzione', 'Nuovi Rituali', 'La Tua Eredità'],
  },
]

export const moduleIncludes: string[] = [
  '🌌 6 Tomi Premium PDF Illustrati',
  '🎁 5 Bonus Premium Inclusi',
  '📄 300+ Pagine di Contenuto',
  '🃏 50 Carte di Frasi di Guarigione',
  '🗺️ Schemi di Costellazione Illustrati in ogni tomo',
  '📊 40 Modelli di Genogramma Professionali',
  '🧩 60 Esercizi Pratici Illustrati Passo-Passo',
  '🧘 5 Meditazioni Guidate Transgenerazionali MP3',
  '📓 Diario di Integrazione Strutturato 90 Giorni',
  '🖨️ Risorse Stampabili Formato A4',
  '♾️ Accesso a Vita · Download Immediato',
]
